export default {
	"longitude": "114.065927",
	"latitude": "22.537361",
	"area_name": "福田区",
	"photo": "[\"s23107\\\/2019\\\/03\\\/25\\\/e4a12f9f81bd3e8f4d.jpg\"]",
	"is_show": 1,
	"mobile": "0755-82722513",
	"takeout_server_status": true,
	"is_open": true,
	"server_status": true,
	"created_at": "1568194697",
	"street": "深圳市福田区海田路与福华一路交汇深圳天元5栋1层N136",
	"area_id": 440304,
	"notice": "",
	"city_name": "深圳市",
	"id_card": "222222222222222222",
	"alipay_store_id": "",
	"takeout_server_time": "10:00-23:59",
	"id": 1,
	"forhere_server_time": "10:00-23:59",
	"province_id": 440000,
	"forhere_is_open": true,
	"is_floor_stall": 0,
	"is_eat": 1,
	"share_description": "",
	"distance": 896,
	"distance_text": "896m",
	"stalls": [],
	"tel": "0755-82722513",
	"is_takeout": 1,
	"images": [
		"https:\/\/img-shop.qmimg.cn\/s23107\/2019\/03\/25\/e4a12f9f81bd3e8f4d.jpg?imageView2\/0\/w\/200\/h\/200"
	],
	"shop_day": "",
	"image": "https:\/\/img-shop.qmimg.cn\/s23107\/2019\/03\/25\/e4a12f9f81bd3e8f4d.jpg",
	"server_time": "10:00-23:59",
	"status": 1,
	"multi_mark": "NXHNSZ0055",
	"per_price": "1.00",
	"balance": "0.00",
	"name": "燕侨大厦",
	"updated_at": "1578227762",
	"packing_fee": "2.00",
	"delivery_cost": "2.00",
	"min_price": "30.00",
	"avg_delivery_cost_time": "40"
}
